import { Component, h } from 'preact';
import { html } from '../../helpers/preact-html';

class MobileNavigationHeader extends Component {
  constructor() {
    super();
  }

  render({ navTree: { header } }) {
    return html`
      <div class="navigation-header">
        ${header.link &&
        html`
          ${header.link.iconClass
            ? html`
                <a class="navigation-linkicon" href=${header.link.href}>
                  <i class="${header.link.iconClass}"></i>
                  <span>${header.link.label}</span>
                </a>
              `
            : html` <a href=${header.link.href}> ${header.link.label} </a> `}
        `}
      </div>
    `;
  }
}

export { MobileNavigationHeader };
